const ProjectTitle = ({ title }) => {
  return (
    <h5 className="summary-p text-lg mb-4">
      <span className=" ">{title}</span>
    </h5>
  );
};

export default ProjectTitle;
